/* eslint-disable @typescript-eslint/no-unsafe-call */
import Stativus from 'stativus';
import { default as loadUIStates } from './ui-states';
import { default as loadDataStates } from './data-states';
let _myStatechart;
const loadStatechart = () => {
    if (_myStatechart) {
        return _myStatechart;
    }
    _myStatechart = Stativus.createStatechart();
    loadUIStates(_myStatechart);
    loadDataStates(_myStatechart);
    return _myStatechart;
};
export default loadStatechart;
